import React from 'react';
import { Route, Routes } from 'react-router-dom';
import classNames from 'classnames';

import 'moment/locale/ru';

import { urls } from '../../utils/routing';
import { 
  //getCookie, 
  getUserRole, 
  //setCookie, 
  //deleteCookie 
} from '../../utils/functions';

import ContentPageWrapper from '../../containers/ContentPageWrapper/ContentPageWrapper';

import MediaWrapper from '../../containers/MediaWrapper/MediaWrapper';
import MediaPageWrapper from '../../containers/MediaPageWrapper/MediaPageWrapper';

import Landing from '../../containers/LandingWrapper/LandingWrapper';
import News from '../../containers/NewsWrapper/NewsWrapper';
import Followed from '../../containers/FollowedWrapper/FollowedWrapper';
import SectionModder from '../../containers/SectionModderWrapper/SectionModderWrapper';
import EditMod from '../../containers/EditModWrapper/EditModWrapper';
import CreateMod from '../../containers/CreateModWrapper/CreateModWrapper';
//import Eula from '../../containers/EulaWrapper/EulaWrapper';
//import TermsOfUse from '../../containers/TermsOfUseWrapper/TermsOfUseWrapper';
import Error404 from '../Error404/Error404';
import SearchPage from '../../containers/SearchPageWrapper/SearchPageWrapper';
import ModPage from '../../containers/ModPageWrapper/ModPageWrapper';

//import UserMenuWrapper from '../../containers/UserMenuWrapper/UserMenuWrapper';
import Dialog from '../../containers/DialogWrapper/DialogWrapper';
import DialogError from '../../containers/DialogErrorWrapper/DialogErrorWrapper';
import Processing from '../../containers/ProcessingWrapper/ProcessingWrapper';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import ShopBasket from '../ShopBasket/ShopBasket';

import SignIn from '../../containers/SignInWrapper/SignInWrapper';
import SignUp from '../../containers/SignUpWrapper/SignUpWrapper';
import Prolongate from '../../containers/ProlongateWrapper/ProlongateWrapper';
import Logout from '../../containers/LogoutWrapper/LogoutWrapper';

import AdminWrapper from '../../containers/AdminWrapper/AdminWrapper';
import SupportAdminWrapper from '../../containers/AdminWrapper/SupportWrapper/SupportWrapper';
import TicketViewWrapper from '../../containers/AdminWrapper/TicketViewWrapper/TicketViewWrapper';
import Support from '../../containers/SupportWrapper/SupportWrapper'; /* for user - link /support/ */
import SupportMyTicketsWrapper from '../../containers/SupportWrapper/SupportMyTicketsWrapper/SupportMyTicketsWrapper';
import ReviewMod from '../../containers/ReviewModWrapper/ReviewModWrapper';

import UnavailablePageWrapper from '../../containers/UnavailablePageWrapper/UnavailablePageWrapper';

import DownloadWrapper from '../../containers/DownloadWrapper/DownloadWrapper';

import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import CookieBannerWrapper from '../../containers/CookieBannerWrapper/CookieBannerWrapper';
import CookieSettingsWrapper from '../../containers/CookieSettingsWrapper/CookieSettingsWrapper';
// import DialogReportMod from './components/Dialogs/DialogReportMod/DialogReportMod';

import styles from './App.module.css'; // App styles

export const ThemeContext = React.createContext('light')

export default class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      orders: [],
      isAnimate: false,
      isDisabledBtnAddCart: false,
      isDisabledCart: true,
    }

    this.addToOrder = this.addToOrder.bind(this)
    this.deleteOrder = this.deleteOrder.bind(this)
    this.clearCart = this.clearCart.bind(this)
    this.disabledCartItemBtnAdd = this.disabledCartItemBtnAdd.bind(this)

    this.checkPathnameForCart = this.checkPathnameForCart.bind(this)
  }

  componentDidMount() {
    this.checkPathnameForCart()
  }

  componentDidUpdate() {
    /*let locStor = []
    let storedData = localStorage.getItem('tm:data')
    debugger
    if (storedData) {
      locStor = Object.entries(JSON.parse(storedData).basketCart.orders)
      locStor = this.state.orders//.push(this.state.orders)
      let valueStorage = JSON.stringify({basketCart: {orders: locStor}})
      localStorage.setItem('tm:data', valueStorage)
    }*/
  }

  checkPathnameForCart() {
    if (window.location.pathname === urls.landing || window.location.pathname === urls.search || window.location.pathname === urls.subscriptions) {
      this.setState({isDisabledCart: false})
    }
  }

  addToOrder(item) {
    let allSizes = 0
    this.state.orders.forEach(el => allSizes += el.modSize)
    allSizes += item.modSize

    /*if (this.state.orders.length+1 === 10) {
      this.setState({isDisabledBtnAddCart: true})
    }*/

    if (this.state.orders.length+1 <= 10) {
      if (allSizes <= 500000000) { // 500 Mb
        let isInArray = false
        this.state.orders.forEach(el => {
          if (el.id === item.id) 
            isInArray = true
        })
        if (!isInArray) {
          this.setState({orders: [...this.state.orders, item], isAnimate: !this.state.isAnimate})
          setTimeout(() => this.setState({isAnimate: !this.state.isAnimate}), 200)
        } else {
          alert(`${item.title} - уже добавлен в корзину!`) 
        }
      } else {
        alert(`Невозможно добавить в корзину. Максимальный объем корзины - 500 Мб!`)
      } // end of IF allSizes
    } else {
      alert(`Невозможно добавить в корзину. Максимальный объем корзины - 10 модификаций!`)
    } // end of IF length <= 10
  }

  clearCart() {
    window.setTimeout(() => this.setState({orders: []}), 5000)
  }

  deleteOrder(id) {
    /*let locStorName = JSON.parse(localStorage.getItem('tmPersistedValues')) //.basketCart.orders
    let newValueStorage = JSON.stringify(locStorName.filter(el => el.id !== id));
    localStorage.setItem('tmPersistedValues', newValueStorage);*/
    this.setState({orders: this.state.orders.filter(el => el.id !== id)})
  }

  disabledCartItemBtnAdd() {
    if (this.state.orders.length === 2) {
      this.setState({isDisabledBtnAddCart: true})
    }
  }
  
  render() {
    if ((!window.__URLS__.pages.portal) && (getUserRole() !== 'admin')) {
      return <UnavailablePageWrapper />
    } else {
      return (
        <div className={styles.base}>
          <div className={classNames(styles.header)}>
            <Nav {...this.props} />
          </div>
          <div className={styles.body}>
            <Routes>
              <Route exact="true" path={ urls.landing } element={ <Landing {...this.props} onAddOrder={this.addToOrder} isDisabledCartItem={this.state.isDisabledBtnAddCart} /> } />
              {/* <Route path={urls.contentPage} component={ContentPage} /> */}
              <Route path={ urls.contentPages } element={ <ContentPageWrapper {...this.props} /> } />

              <Route path={ urls.media } element={ <MediaWrapper {...this.props} /> } />
              <Route path={ urls.mediaPage } element={ <MediaPageWrapper {...this.props} /> } />

              <Route exact="true" path={`/:modId/`} element={ <ModPage {...this.props} /> } />
              <Route path={ urls.news } element={ <News {...this.props} /> } />
              <Route path={ urls.search } element={ <SearchPage {...this.props} /> } />
              <Route path={ urls.subscriptions } element={ <Followed {...this.props} /> } />
              <Route path={ urls.modderSection } element={ <SectionModder {...this.props} /> } />
              <Route path={ urls.edit } element={ <EditMod {...this.props} /> } />
              <Route path={ urls.create } element={ <CreateMod {...this.props} /> } />
              {/* <Route path={ urls.eula } element={ <Eula {...this.props} /> } /> */}
              {/* <Route path={ urls.termsofuse } element={ <TermsOfUse {...this.props} /> } /> */}
              
              <Route path={ urls.errorNotFound } element={ <Error404 {...this.props} /> } />
              <Route path="*" element={ <Error404 {...this.props} /> } />

              {/* Auth and prolong token */}
              <Route path={ urls.signin } element={ <SignIn {...this.props} /> } />
              <Route path={ urls.signup } element={ <SignUp {...this.props} /> } />
              <Route path={ urls.prolongate } element={ <Prolongate {...this.props} /> } />
              {/* Exit from account */}
              <Route path={ urls.logout } element={ <Logout {...this.props} /> } />

              {/* Admin panel idTicket={this.props.location.pathname}  */}
              <Route path={ urls.adminSection } element={ <AdminWrapper {...this.props} /> } />
              <Route path={ urls.moderatorSection } element={ <AdminWrapper {...this.props} /> } />
              <Route path={ urls.supportSection } element={ <SupportAdminWrapper {...this.props} /> } />
              <Route path={ urls.supportSectionTicketView } element={ <TicketViewWrapper {...this.props} /> } />
              <Route path={ urls.commentsSection } element={ <AdminWrapper {...this.props} /> } />
              <Route path={ urls.usersSection } element={ <AdminWrapper {...this.props} /> } />
              {/* Panel moderator edit mod */}
              <Route path={ urls.review } element={ <ReviewMod {...this.props} /> } />
              {/* Support panel */}
              <Route path={ urls.problemInfo } element={ <Support {...this.props} /> } />
              <Route path={ urls.problemMyTickets } element={ <SupportMyTicketsWrapper {...this.props} /> } />
              {/* Download mods page */}
              <Route path={ urls.downloadPage } element={ <DownloadWrapper {...this.props} /> } />
              {/* <Route path={urls.adminSection} element={  } /> */}
            </Routes>
          </div>
          <CookieBannerWrapper />
          <CookieSettingsWrapper />
          <ScrollToTop />
          <ShopBasket {...this.props} orders={this.state.orders} isAnimate={this.state.isAnimate} deleteOrder={this.deleteOrder} clearCart={this.clearCart} isDisabled={!window.__SETTINGS__.cartEnabled} isDownloading={false} />
          <div className={styles.footer}>
            <Footer {...this.props} />
          </div>
          <Dialog />
          <DialogError />
          <Processing />
        </div>
      )
    } // end of IF
  }
}
